import axios from 'axios';
// import { getCookie } from '@/utils'
export const sharedDataMixin = {
  data() {
    return {
      isLoggedIn: false,
      username: '',
      isSuperAdmin: '用户',
      lastSearchData: null,
      filteredData: [],
      // 添加VIP信息相关数据
      vipInfo: {
        is_vip: false,
        vip_expire_date: null,
        remaining_days: 0
      },
      // 标记是否已经显示过被踢出提示
      kickMessageShown: false
    };
  },
  methods: {
    // 共享的登录状态检查方法
    checkLoginStatus() {
      // const csrftoken = getCookie('csrftoken');
      
      // 调用后端API检查登录状态
      axios.get('api/check-login/', {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
      },

    )
      .then(response => {
        if (response.data.isLoggedIn) {
          this.isLoggedIn = true;
          this.username = response.data.username || '';
          this.isSuperAdmin = response.data.isSuperAdmin || '用户';
          // 重置踢出提示标记
          this.kickMessageShown = false;
        } else {
          // 检测是否是被踢出的（之前登录过，现在未登录）
          if (this.isLoggedIn && !this.kickMessageShown) {
            this.kickMessageShown = true;
            this.$message.warning('您的账号已在其他地方登录，您已被退出');
            // 跳转到登录页
            setTimeout(() => {
              this.$router.push('/login');
            }, 1500);
          }
          this.isLoggedIn = false;
          this.username = '';
          this.isSuperAdmin = '用户';
        }
        // 无论登录状态如何，都获取VIP信息
        this.fetchVipInfo();
      })
      .catch(error => {
        console.error('检查登录状态失败:', error);
        this.isLoggedIn = false;
        this.username = '';
        this.isSuperAdmin = '用户';
        // 错误时也尝试获取VIP信息
        this.fetchVipInfo();
      });
    },
    
    // 获取VIP信息的方法
    fetchVipInfo() {
      // const csrftoken = getCookie('csrftoken');
      
      axios.get('api/vip-info/', {
        // withCredentials: true,
        // headers: { 'X-Csrftoken': csrftoken }
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-Csrftoken',
      })
      .then(response => {
        this.vipInfo = response.data;
      })
      .catch(error => {
        console.error('获取VIP信息失败:', error);
        this.vipInfo = {
          is_vip: false,
          vip_expire_date: null,
          remaining_days: 0
        };
      });
    },
    
    // 获取Cookie
    getCookie(name) {
      let cookieValue = null;
      if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();
          if (cookie.substring(0, name.length + 1) === (name + '=')) {
            cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
            break;
          }
        }
      }
      return cookieValue;
    }
  }
};